import React from 'react';
import { Heading, Body } from '../Constants/Fonts';
import './PageHeading.css';

/**
 * PageHeading — the standard screen-title block used across the app
 * (AI Adoption + AI Adoption Portal, and reusable anywhere else).
 *
 * The title renders through the shared `Heading` component from
 * `src/Constants/Fonts.js` (and the subtitle through `Body`) so every screen's
 * heading is visually identical and a global type change is a one-line edit in
 * Fonts.js. Supports an optional subtitle and a right-aligned `actions` slot
 * (buttons, tabs, filters…).
 *
 *   <PageHeading
 *       title={`Detection Signatures (${rows.length})`}
 *       subtitle="Pattern catalogue the endpoint scanner + browser extension use…"
 *       actions={<CommonTabs … />}
 *   />
 *
 * Props:
 *   title    : node                 — the screen name (required)
 *   subtitle : node                 — optional supporting line under the title
 *   actions  : node                 — optional right-aligned content
 *   level    : 1 | 2 | 3            — which Heading variant to use (default 3),
 *                                     matching the dashboard section headings like
 *                                     "Governance, Risk & Compliance (GRC)")
 *   children : node                 — alias/extra content in the actions slot
 *   className: extra class on the wrapper
 */
function PageHeading({ title, subtitle, actions, level = 3, children, className }) {
    return (
        <div className={`page_heading ${className || ''}`.trim()}>
            <div className="page_heading__text">
                <Heading as="h1" variant={level} className="page_heading__title" color="var(--color-text-primary)" style={{ margin: 0 }}>
                    {title}
                </Heading>
                {subtitle && (
                    <Body as="p" variant={2} className="page_heading__subtitle" style={{ margin: '4px 0 0' }}>
                        {subtitle}
                    </Body>
                )}
            </div>
            {(actions || children) && (
                <div className="page_heading__actions">{actions || children}</div>
            )}
        </div>
    );
}

export default PageHeading;
